var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShutdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.184,
    height: 23.001,
    viewBox: "0 0 21.184 23.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "shutdown") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00a0e9;}.b{fill:none;stroke:#00a0e9;stroke-linecap:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-4401.816,305.821a10.523,10.523,0,0,1-7.489-3.1,10.522,10.522,0,0,1-3.1-7.49,10.516,10.516,0,0,1,3.1-7.488,10.7,10.7,0,0,1,1.9-1.512l1.275,2.74a7.615,7.615,0,0,0-3.292,6.26,7.614,7.614,0,0,0,7.605,7.607,7.615,7.615,0,0,0,7.606-7.607,7.594,7.594,0,0,0-3.43-6.354l1.418-2.636a10.689,10.689,0,0,1,3.623,3.777,10.575,10.575,0,0,1,1.374,5.213A10.6,10.6,0,0,1-4401.816,305.821Z",
    transform: "translate(4412.408 -284.32)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 9.915,
    transform: "translate(10.923)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShutdown);
export default __webpack_public_path__ + "static/media/shutdown.48c96a4260503d49579878fcb1084734.svg";
export { ForwardRef as ReactComponent };